import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'

import styles from '../styles.module.css'
import Navbar from 'app/GNNPage/components/Navbar'
import ItemList from 'app/GNNPage/components/ItemList'
import AboutGNNDialog, {
  showTentangGnnDialog,
} from 'app/GNNPage/components/AboutGNNDialog'

const Layout: React.FC = ({ children }) => {
  const router = useRouter()
  return (
    <>
      <div className="flex min-h-screen flex-col">
        <header className="sticky top-0 z-50 w-full border-b bg-white">
          <div
            className={clsx(
              styles['container'],
              'flex h-16 items-center justify-between px-4 md:px-8'
            )}
          >
            <Link href="/gnn">
              <div className="flex items-center gap-2 cursor-pointer">
                <Image
                  className="mt-3"
                  priority
                  src={'/images/gnn/logo.png'}
                  alt={'GNN'}
                  height={35}
                  width={30}
                />
                <span className="text-xl font-bold">
                  Gerakan Numerasi Nasional
                </span>
              </div>
            </Link>
            <Navbar />
          </div>
        </header>
        {children}
        <footer className="bg-gray-900 py-12 sticky top-full">
          <div
            className={clsx(
              styles['container'],
              'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'
            )}
          >
            <div className="grid md:grid-cols-2 gap-10">
              <div className="flex flex-col gap-3">
                <Text color="inverse" as="h3" variant="display-sm">
                  Gerakan Numerasi Nasional
                </Text>
                <Text color="inverse-subdued">
                  Gerakan Numerasi Nasional merupakan inisiatif strategis yang
                  bertujuan untuk meningkatkan kemampuan numerasi bagi
                  masyarakat di seluruh Indonesia. Sejalan dengan agenda
                  pembangunan pendidikan nasional, gerakan ini berupaya
                  menumbuhkan budaya berpikir kritis, logis, dan analitis di
                  berbagai kalangan masyarakat.
                </Text>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
                <div>
                  <Text variant="heading-md" color="inverse">
                    Tautan Cepat
                  </Text>
                  <ItemList
                    items={[
                      {
                        label: 'Beranda',
                        onClick() {
                          router.push('/gnn')
                        },
                      },
                      {
                        label: 'Tentang GNN',
                        onClick() {
                          showTentangGnnDialog()
                        },
                      },
                      {
                        label: 'Sumber Belajar',
                        onClick() {
                          router.push('/gnn/sumber-belajar')
                        },
                      },
                      {
                        label: 'Gerai Numerasi',
                        onClick() {
                          window
                            .open(
                              'https://sindara.gurudikdas.kemendikdasmen.go.id/gerai-numerasi',
                              '_blank'
                            )
                            ?.focus()
                        },
                      },
                    ]}
                  />
                </div>
                <div className="col-span-2">
                  <Text variant="heading-md" color="inverse">
                    Kontak
                  </Text>
                  <ul className="py-3 space-y-2">
                    <li className="flex gap-2">
                      <Icon fontSize="sm" color="inverse">
                        pin_drop
                      </Icon>
                      <Text color="inverse" variant="body-sm">
                        Komp. Kemdikbud Ged. C Lt. 15 Jl. Jend. Sudirman,
                        Senayan, Jakarta 10270
                      </Text>
                    </li>
                    <li className="flex gap-2">
                      <Icon fontSize="sm" color="inverse">
                        call
                      </Icon>
                      <Text color="inverse" variant="body-sm">
                        (021) 21684364
                      </Text>
                    </li>
                    <li className="flex gap-2">
                      <Icon fontSize="sm" color="inverse">
                        mail
                      </Icon>
                      <div className="flex flex-col gap-0.5">
                        <Text color="inverse" variant="body-sm">
                          guru.dikdas@dikbud.belajar.id
                        </Text>
                        <Text color="inverse" variant="body-sm">
                          guru.dikdas@kemdikbud.go.id
                        </Text>
                      </div>
                    </li>
                    <li className="flex gap-2">
                      <Icon fontSize="sm" color="inverse">
                        headset_mic
                      </Icon>
                      <a
                        href="https://sindara.gurudikdas.kemendikdasmen.go.id/#pusatBantuan"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Text
                          color="inverse"
                          variant="body-sm"
                          className="underline"
                        >
                          Pusat Bantuan
                        </Text>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-700 mt-8 pt-8 text-center">
              <Text variant="helper" color="inverse-subdued">
                &copy; {new Date().getFullYear()} Gerakan Numerasi Nasional. Hak
                cipta dilindungi undang-undang.
              </Text>
            </div>
          </div>
        </footer>
      </div>
      <AboutGNNDialog />
    </>
  )
}

export default Layout
